import readXlsxFile from "read-excel-file";

export const getLines = async (data: any) => {
  return await readXlsxFile(data);
};
